<template>
    <transition name="fade" mode="in-out">
        <div class="c-modal" ref="modal" @click="closeOnOverlay">
            <div class="c-modal__panel" :class="size">
                <h2 v-if="title">{{title}}</h2>

                <slot></slot>

                <button class="close-button" @click.prevent="$emit('close')" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },
        size: {
            type: String,
            default: ''
        }
    },
    methods: {
        closeOnOverlay(event) {
            if ( event.target == this.$refs.modal ) {
                this.$emit('close');
            }
        },
        modalClosed() {
        }
    },
    created(){
        this.$on('close', this.modalClosed);
    }
}
</script>
